module.exports = __webpack_public_path__ + "img/picz_logo_white_small.98d20e52.svg";